module.exports = __webpack_public_path__ + "img/apple_soon.52fdf003.png";